<template>

  <div class="card directory-list-card directory-management-card">
    <div class="card-header directory-list-card__header">
      <div class="directory-list-card__title">
        <h4>{{ $t('Region Directory') }}</h4>
      </div>
    </div>
    <div class="card-body directory-management-card__body">
      <div class="directory-management-grid">
        <div class="directory-management-form-panel">
          <RegionForm></RegionForm>
        </div>
        <div class="directory-management-list-panel">
          <Loader v-if="regionList.totalDocs===undefined"></Loader>
          <RegionList v-else></RegionList>
        </div>
      </div>
    </div>
  </div>

  <Modal idModal="UpdateRegionModal" :headerTitle="$t('Edit Region')">
    <div class="user-modal-form">
      <div class="form-group">
        <label :class="{ 'required-style': !regionDataUpdate.regionName }">{{ $t('Region Name') }}</label>
        <input type="text" class="form-control" v-model="regionDataUpdate.regionName" :placeholder="$t('Region Name')"/>
         <span class="text-warning" v-if="!regionDataUpdate.regionName && isClicked">{{ $t('Required') }}</span>
      </div>
    </div>
    <template v-slot:actions>
    <button type="button" ref="closeAddModal" class="btn user-modal-btn user-modal-btn--cancel" data-bs-dismiss="modal">{{ $t('Cancel') }}</button>
    <button class="btn user-modal-btn user-modal-btn--submit" v-if="regionDataUpdate._id" ref="updateBtn" @click="UpdateRegion">{{ $t('Save Changes') }}</button>
    </template>
  </Modal>


</template>

<script>
import RegionList from '@/components/directoryInfo/Region/RegionList.vue'
import RegionForm from '@/components/directoryInfo/Region/RegionForm.vue'
import Modal from '@/components/layout/Modal.vue'
import Loader from '@/components/layout/Loader.vue'
import { LinkList } from '@/helpers/utilities.js'
import {mapGetters, mapActions} from 'vuex'
import {showDirectoryError} from '@/helpers/directoryErrorAlert.js'
import {showDirectorySuccess} from '@/helpers/directorySuccessAlert.js'
import {showDirectoryLoading, closeDirectoryLoading} from '@/helpers/directoryLoadingAlert.js'
export default {
  name: 'Region',
  components: {
    RegionList,
    RegionForm,
    Modal,
    Loader
  },
  data(){
    return {
      isClicked :false
    }
  },
  mounted : function(){
    this.GetRegionList().catch()
    this.$store.commit('setActiveLink',LinkList.MAIN_COMPANY)
  },
  methods:{
    ...mapActions(['GetRegionList','UpdateRegionRun']),
    UpdateRegion(){
      const self = this
      const btn = self.$refs.updateBtn
      let data = self.regionDataUpdate
      self.isClicked = true
      if(!data.regionName){
          return
      }
      
      btn.disabled = true
      self.isClicked = false
      showDirectoryLoading(self, {
        title: 'Updating Region',
        description: 'Saving the region changes and updating the directory.'
      })

      self.UpdateRegionRun(data).then((res)=>{
          btn.disabled = false
          if(res=="OK"){
              self.$refs.closeAddModal.click()
              closeDirectoryLoading(self)
              showDirectorySuccess(self, {
                description: 'The region details have been updated successfully.'
              })
          }else{
              closeDirectoryLoading(self)
              showDirectoryError(self, {
                description: res,
                duplicateValue: data.regionName
              })
          }
      }).catch((error)=>{
          btn.disabled = false
          closeDirectoryLoading(self)
          showDirectoryError(self, {
            description: error?.message || 'Unable to update region. Please try again.',
            duplicateValue: data.regionName
          })
      })
    }
  },
  computed : mapGetters(['regionList','regionDataUpdate'])

}
</script>
